import React from 'react'
import { graphql } from "gatsby";
import { linkFormat } from '../../utilities/linkFormat'

export default function CtaButton({ data }) {
  return (
    <a className="CtaButton text-center block hds-container mb-12" href={data.link? linkFormat(data.link) : ''}>
      <button className="fg-btn">{data.text}</button>
    </a>
  )
}

export const ctaButtonQuery = graphql`
  fragment CtaButtonComponent on DatoCmsCtaButton {
    internal {
      type
    }
    id
    link
    text
  }
`;
